module.exports = __webpack_public_path__ + "static/media/IMG_7019 edit.4027b266.JPG";